import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
    <defs>
      <path id="apps-a"
            d="M2,4 L2,2 L4,2 L4,4 L2,4 Z M7,4 L7,2 L9,2 L9,4 L7,4 Z M12,4 L12,2 L14,2 L14,4 L12,4 Z M2,9 L2,7 L4,7 L4,9 L2,9 Z M7,9 L7,7 L9,7 L9,9 L7,9 Z M12,9 L12,7 L14,7 L14,9 L12,9 Z M2,14 L2,12 L4,12 L4,14 L2,14 Z M7,14 L7,12 L9,12 L9,14 L7,14 Z M12,14 L12,12 L14,12 L14,14 L12,14 Z"/>
    </defs>
    <g>
      <use xlinkHref="#apps-a"/>
    </g>
  </svg>
);
